module.exports = __webpack_public_path__ + "img/wheelchair.97e8cada.png";